<template>
    <card-renderless v-slot="{ title, subtitle, link, image, applications }">
        <div class="relative flex flex-col w-full h-full bg-white rounded shadow-md select-none t3m-ProductList-product t3m-Card t3m-Card--flexColumn t3m-Card--flx t3m-Card--flx-loose card"
             itemprop="isRelatedTo">
            <a class="t3m-Card-image-wrapper card-img-top"
               :href="link"
               :aria-label="title">
                <figure class="relative flex justify-center rounded-t aspect-card-image">
                    <img class="object-cover w-full h-full mx-auto rounded-t swiper-lazy"
                         title=""
                         alt=""
                         :data-src="image" />
                    <div class="swiper-lazy-preloader"></div>
                </figure>
            </a>

            <div class="relative flex-grow max-h-full p-4">
                <h3 class="mt-0 mb-2 font-bold t3m-Card-title card-title">
                    <a class="text-inherit hover:text-primary"
                        v-html="title"
                       :href="link"
                       :aria-label="title"></a>
                </h3>
                <p v-html="subtitle" class="text-sm t3m-Card-text"></p>
            </div>

            <div class="flex items-end p-3 text-xs bg-gray-200 rounded-b t3m-Card-footer card-footer">
                <div class="mr-2 t3m-ProductList-product-applications">
                    <span v-for="(ap, indx) in applications"
                          :key="indx">
                        <span v-if="indx != 0">, </span><a class="no-underline text-t3m-muted hover:text-primary"
                           :href="ap.link" v-html="ap.title"></a>
                    </span>
                </div>
                <a v-if="link.length"
                   class="inline-block !ml-auto p-0.5 text-white rounded-full hover:text-white t3m-Card-btn t3m-btn-primary-icon-plus-xs bg-primary hover:bg-primary-hover"
                   :href="link"
                   aria-label="Product details">
                    <span class="sr-only">
                        Product details
                    </span>
                    <svg xmlns="http://www.w3.org/2000/svg"
                         class="w-3 h-3"
                         viewBox="0 0 448 512"
                         fill="currentColor">
                        <path
                              d="M432 256C432 269.3 421.3 280 408 280h-160v160c0 13.25-10.75 24.01-24 24.01S200 453.3 200 440v-160h-160c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h160v-160c0-13.25 10.75-23.99 24-23.99S248 58.75 248 72v160h160C421.3 232 432 242.8 432 256z" />
                    </svg>
                </a>
            </div>
        </div>
    </card-renderless>
</template>

<script>
import CardRenderless from "@/components/Card/CardRenderless";
export default {
    components: {
        CardRenderless,
    },
};
</script>
